var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepoimentos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.165 40.8525C31.2853 40.8525 37.0575 40.1742 37.0575 39.3375C37.0575 38.5008 31.2853 37.8225 24.165 37.8225C17.0446 37.8225 11.2725 38.5008 11.2725 39.3375C11.2725 40.1742 17.0446 40.8525 24.165 40.8525Z",
    fill: "#5731FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6625 27.855C37.725 25.6725 38.955 22.8825 38.955 19.8525C38.955 12.825 32.3325 7.125 24.165 7.125C15.9975 7.125 9.375 12.825 9.375 19.8525C9.375 26.88 15.9975 32.58 24.165 32.58C27.0675 32.58 29.775 31.86 32.055 30.615L37.5 32.715L35.6625 27.8625V27.855Z",
    fill: "#FD9D00",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7598 22.4026C11.9248 22.9726 12.1498 23.5276 12.4198 24.0601C12.7648 24.7351 13.7023 24.7726 14.1298 24.1501C18.1723 18.2401 24.9898 14.7151 30.1723 12.7651C31.2298 12.3676 31.2673 10.8976 30.2398 10.4251C28.9348 9.83257 27.4948 9.42007 25.9648 9.24007C25.4548 9.18007 24.9223 9.24007 24.4498 9.45007C18.2698 12.2026 14.3023 17.0026 11.9998 20.7226C11.6848 21.2251 11.5948 21.8401 11.7598 22.4101V22.4026Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1049 25.5749C25.1249 20.2874 32.2799 19.2899 35.7074 19.1624C36.3224 19.1399 36.7499 18.5549 36.6149 17.9549C36.3599 16.8674 36.0824 16.1474 35.8724 15.7124C35.7074 15.3674 35.3324 15.1649 34.9499 15.2024C24.1949 16.3274 17.5574 21.6749 14.5799 24.7274C14.1899 25.1324 14.6174 25.8224 15.0974 25.5749H15.1049Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8604 16.8301L17.8429 18.6301L19.8604 19.0126L18.4504 20.4976L18.7204 22.5376L16.8604 21.6526L15.0079 22.5376L15.2704 20.4976L13.8604 19.0126L15.8779 18.6301L16.8604 16.8301Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.165 16.8301L25.1475 18.6301L27.165 19.0126L25.755 20.4976L26.0175 22.5376L24.165 21.6526L22.3125 22.5376L22.575 20.4976L21.165 19.0126L23.1825 18.6301L24.165 16.8301Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4707 16.8301L32.4532 18.6301L34.4707 19.0126L33.0607 20.4976L33.3232 22.5376L31.4707 21.6526L29.6182 22.5376L29.8807 20.4976L28.4707 19.0126L30.4882 18.6301L31.4707 16.8301Z",
    fill: "#8CD1BF",
    stroke: "#5731FF",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepoimentos);
export default __webpack_public_path__ + "static/media/depoimentos.4d83aad2.svg";
export { ForwardRef as ReactComponent };